import { render, staticRenderFns } from "./entegra.vue?vue&type=template&id=2ab94dd1&scoped=true"
import script from "./entegra.vue?vue&type=script&lang=js"
export * from "./entegra.vue?vue&type=script&lang=js"
import style0 from "./entegra.vue?vue&type=style&index=0&id=2ab94dd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab94dd1",
  null
  
)

export default component.exports